import { render, staticRenderFns } from "./ForwardEmailOptionsModal.vue?vue&type=template&id=4b29130e&scoped=true"
import script from "./ForwardEmailOptionsModal.vue?vue&type=script&lang=js"
export * from "./ForwardEmailOptionsModal.vue?vue&type=script&lang=js"
import style0 from "./ForwardEmailOptionsModal.vue?vue&type=style&index=0&id=4b29130e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b29130e",
  null
  
)

export default component.exports